/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TimeClockStopwatchIcon16Light } from './TimeClockStopwatchIcon16Light';
import { TimeClockStopwatchIcon16Regular } from './TimeClockStopwatchIcon16Regular';
import { TimeClockStopwatchIcon16Solid } from './TimeClockStopwatchIcon16Solid';
import { TimeClockStopwatchIcon20Light } from './TimeClockStopwatchIcon20Light';
import { TimeClockStopwatchIcon20Regular } from './TimeClockStopwatchIcon20Regular';
import { TimeClockStopwatchIcon20Solid } from './TimeClockStopwatchIcon20Solid';
import { TimeClockStopwatchIcon24Regular } from './TimeClockStopwatchIcon24Regular';
import { TimeClockStopwatchIcon24Solid } from './TimeClockStopwatchIcon24Solid';
import { TimeClockStopwatchIcon32Regular } from './TimeClockStopwatchIcon32Regular';
import { TimeClockStopwatchIcon64Regular } from './TimeClockStopwatchIcon64Regular';
var sizes = {
    16: {
        light: TimeClockStopwatchIcon16Light,
        regular: TimeClockStopwatchIcon16Regular,
        solid: TimeClockStopwatchIcon16Solid,
    },
    20: {
        light: TimeClockStopwatchIcon20Light,
        regular: TimeClockStopwatchIcon20Regular,
        solid: TimeClockStopwatchIcon20Solid,
    },
    24: {
        regular: TimeClockStopwatchIcon24Regular,
        solid: TimeClockStopwatchIcon24Solid,
    },
    32: {
        regular: TimeClockStopwatchIcon32Regular,
    },
    64: {
        regular: TimeClockStopwatchIcon64Regular,
    },
};
export var TimeClockStopwatchIcon = forwardRef('TimeClockStopwatchIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
